module.exports = __webpack_public_path__ + "media/4x3/es-ca-e9062265.svg";